import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { useStyles } from './styles'
import { numberWithCommas } from '../../../../utils'

const StoriesInformation = ({ data: { stories } }) => {
  const classes = useStyles()
  return (
    <Grid container item xs={12} className={classes.generalInfo}>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {numberWithCommas(stories.total)}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              Total Stories
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {numberWithCommas(Math.round((stories.perLearner + Number.EPSILON) * 10) / 10)}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              Stories per Learner
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {numberWithCommas(Math.round((stories.perDay + Number.EPSILON) * 10) / 10)}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              Stories per Day
            </Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

export default StoriesInformation
